<template>
    <v-content>
        <!-- Header -->
        <Header id="header"></Header>
        <!-- End-Header -->

        <v-layout>
            <!-- Menu bar -->
            <template>
                <v-content style="background-color: #FAF5F2">
                    <v-card flat tile height="100%" width="250px" style="background-color: #544A44">
                        <v-expansion-panels class="pa-0 ma-0" accordion tile flat>

                            <!-- <v-layout :class="activeMainMenu ? 'active-main-menu' : ''">
                               <v-flex class="text-start pl-6 py-4 hover-sidebar" style="color: white" @click="onClick('activeMainMenu')">
                                   Dashboard {{activeMainMenu}}
                               </v-flex>
                           </v-layout> -->

                            <v-expansion-panel style="background-color: #544A44; color: white" class="header-side-menu"
                                v-for="(item, i) in checkRole()" :key="i">
                                <v-expansion-panel-header @click="onClick(item)"
                                    :style="[item.active ? { 'background-color': '#3E7662' } : { 'background-color': '' }]">
                                    {{ item.text }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content class="fix-margin" color="#fff">
                                    <v-list-item class="fix-list-item" v-for="sublink in item.subLinks" :to="sublink.to"
                                        :key="sublink.text">
                                        <v-list-item-content>
                                            <v-list-item-title class="py-2 side-menu" v-text="sublink.text"
                                                @click="$router.push(sublink.to)" />
                                        </v-list-item-content>

                                        <v-list-item-icon v-if="sublink.count" class="fix-list-icon pt-1">
                                            <v-icon small color="#CC3D45">mdi-alert-circle</v-icon>
                                            <span style="color: #CC3D45;font-weight: bold;font-size: 14px;">{{ sublink.count
                                            }}</span>
                                        </v-list-item-icon>
                                    </v-list-item>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-card>
                </v-content>
            </template>
            <!-- End Menu bar -->

            <!-- Detail -->
            <template>
                <v-content style="width: calc(100% - 256px); background-color: #FAF5F2">
                    <router-view />
                </v-content>
            </template>
            <!-- End Detail -->
        </v-layout>

        <!-- Footer -->
        <Footer id="footer"></Footer>
        <!-- End-Footer -->
    </v-content>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Header from "../components/main-layout/Header";
import Footer from "../components/main-layout/Footer";
export default {
    name: "MainLayout",
    components: {
        Header,
        Footer,
    },
    data: () => ({
        cssActive: false,
        drawer: true,
        mini: false,
        item1: 1,
        activeMainMenu: false,
        //เจ้าหน้าที่
        linksRole_1: [
            {
                active: false,
                text: 'Dashboard',
                subLinks: [
                    { text: 'ข้อมูลจำนวนโครงร่างในแต่ละปี', to: '/dashboard' },
                ]
            },
            {
                active: false,
                text: 'การจัดการข่าวสาร',
                subLinks: [
                    {
                        text: 'ข่าวสารทั้งหมด',
                        to: '/all-news',
                    },
                ]
            },
            {
                active: false,
                text: 'การจัดการการประชุม',
                subLinks: [
                    {
                        text: 'จัดการการประชุม',
                        to: '/meeting',
                    },
                    {
                        text: 'จัดการการประชุมย่อย',
                        to: '/sub-meeting',
                    },
                    // {
                    //     text : 'ผู้เข้าร่วมการประชุม',
                    //     to    : '/meeting-attendees',
                    // },
                ]
            },
            {
                active: false,
                text: 'การจัดการผู้ใช้งาน',
                subLinks: [
                    {
                        text: 'จัดการผู้ใช้งาน',
                        to: '/user-management',
                        count: '',
                    },
                    {
                        text: 'จัดการ Admin',
                        to: '/admin-management',
                        count: '',
                    },
                    {
                        text: 'จัดการใบ Certificate',
                        to: '/certificate-management',
                        count: '',
                    },
                ]
            },
            {
                active: false,
                text: 'การจัดการงานวิจัย (Pre-Approval)',
                subLinks: [
                    { text: 'งานวิจัยใหม่', to: '/new-research', count: '' },
                    { text: 'งานวิจัยทั้งหมด', to: '/all-research', count: '' },
                    { text: 'โครงการที่รอระบุประเภทการพิจารณา', to: '/verified-research', count: '' },
                    { text: 'ประเมิน (อนุกรรมการ)', to: '/research-approve' },
                    { text: 'รอการอนุมัติ(ประธาน)', to: '/research-approve-leader', count: '' },
                    { text: 'งานวิจัยขอยกเลิกโครงการ', to: '/research-cancel', count: '' },

                ]
            },
            {
                active: false,
                text: 'การจัดการงานวิจัย (Post-Approval)',
                subLinks: [
                    { text: 'ตรวจสอบแบบฟอร์ม RF', to: '/verify-rf', count: '' },
                    { text: 'พิจารณาแบบฟอร์ม RF', to: '/verify-rf-all', count: '' },
                    { text: 'ประเมิน (อนุกรรมการ)', to: '/post-approve' },
                    { text: 'รอการอนุมัติ(ประธาน)', to: '/approve-rf', count: '' },
                ]
            },
            {
                active: false,
                text: 'การจัดการทั่วไป',
                subLinks: [
                    { text: 'จัดการแหล่งทุนวิจัย', to: '/budget-resource' },
                    { text: 'จัดการสังกัด', to: '/party' },
                ]
            },
        ],
        //เลขา
        linksRole_2: [
            {
                active: false,
                text: 'Dashboard',
                subLinks: [
                    { text: 'ข้อมูลจำนวนโครงร่างในแต่ละปี', to: '/dashboard' },
                ]
            },
            {
                active: false,
                text: 'การจัดการข่าวสาร',
                subLinks: [
                    {
                        text: 'ข่าวสารทั้งหมด',
                        to: '/all-news',
                    },
                ]
            },
            {
                active: false,
                text: 'การจัดการการประชุม',
                subLinks: [
                    {
                        text: 'จัดการการประชุม',
                        to: '/meeting',
                    },
                    {
                        text: 'จัดการการประชุมย่อย',
                        to: '/sub-meeting',
                    },
                    // {
                    //     text : 'เข้าร่วมการประชุม(อนุกรรมการ)',
                    //     to    : '/join-meeting',
                    // },
                ]
            },
            {
                active: false,
                text: 'การจัดการผู้ใช้งาน',
                subLinks: [
                    {
                        text: 'จัดการผู้ใช้งาน',
                        to: '/user-management',
                        // count: '',
                        // count: '',
                    },
                    {
                        text: 'จัดการใบ Certificate',
                        to: '/certificate-management',
                        // count: '',
                    },
                ]
            },
            {
                active: false,
                text: 'การจัดการงานวิจัย (Pre-Approval)',
                subLinks: [
                    // { text: 'งานวิจัยใหม่', to: '/new-research', count: ''},
                    // { text : 'งานวิจัยทั้งหมด', to: '/all-research', count: ''},
                    { text: 'โครงการที่รอระบุประเภทการพิจารณา', to: '/verified-research', count: ''},
                    // { text: 'ประเมิน (อนุกรรมการ)', to: '/research-approve' },
                    // { text: 'รอการอนุมัติ(ประธาน)', to: '/research-approve-leader', count:''},
                ]
            },
            {
                active: false,
                text: 'การจัดการงานวิจัย (Post-Approval)',
                subLinks: [
                    { text: 'ตรวจสอบแบบฟอร์ม RF', to: '/verify-rf'},
                    { text: 'พิจารณาแบบฟอร์ม RF', to: '/verify-rf-all'},
                    { text: 'ประเมิน (อนุกรรมการ)', to: '/post-approve' },
                    { text: 'รอการอนุมัติ(ประธาน)', to: '/approve-rf'},
                ]
            },
            {
                active: false,
                text: 'การจัดการทั่วไป',
                subLinks: [
                    { text: 'จัดการแหล่งทุนวิจัย', to: '/budget-resource' },
                    { text: 'จัดการสังกัด', to: '/party' },
                ]
            },
        ],
        //อนุกรรมการ
        linksRole_3: [
            {
                active: false,
                text: 'Dashboard',
                subLinks: [
                    { text: 'ข้อมูลจำนวนโครงร่างในแต่ละปี', to: '/dashboard' },
                ]
            },
            {
                active: false,
                text: 'การจัดการข่าวสาร',
                subLinks: [
                    {
                        text: 'ข่าวสารทั้งหมด',
                        to: '/all-news',
                    },
                ]
            },
            {
                active: false,
                text: 'การจัดการการประชุม',
                subLinks: [
                    {
                        text: 'จัดการการประชุม',
                        to: '/meeting',
                    },
                    {
                        text: 'จัดการการประชุมย่อย',
                        to: '/sub-meeting',
                    },
                    // {
                    //     text : 'เข้าร่วมการประชุม(อนุกรรมการ)',
                    //     to    : '/join-meeting',
                    // },
                ]
            },
            // {
            //     active: false,
            //     text : 'การจัดการผู้ใช้งาน',
            //     subLinks : [
            //         {
            //             text : 'จัดการผู้ใช้งาน',
            //             to    : '/user-management',
            //             count: '',
            //         },
            //         {
            //             text : 'จัดการใบ Certificate',
            //             to    : '/certificate-management',
            //             count: '',
            //         },
            //     ]
            // },
            {
                active: false,
                text: 'การจัดการงานวิจัย (Pre-Approval)',
                subLinks: [
                    // { text: 'งานวิจัยใหม่', to: '/new-research', count: ''},
                    // { text : 'งานวิจัยทั้งหมด', to: '/all-research', count: ''},
                    // { text : 'โครงการที่รอระบุประเภทการพิจารณา', to: '/verified-research',count: ''},
                    { text: 'ประเมิน (อนุกรรมการ)', to: '/research-approve' },
                    // { text: 'รอการอนุมัติ(ประธาน)', to: '/research-approve-leader', count:''},
                ]
            },
            {
                active: false,
                text: 'การจัดการงานวิจัย (Post-Approval)',
                subLinks: [
                    // { text : 'ตรวจสอบแบบฟอร์ม RF', to: '/verify-rf', count: '' },
                    // { text : 'พิจารณาแบบฟอร์ม RF', to: '/verify-rf-all', count: ''},
                    { text: 'ประเมิน (อนุกรรมการ)', to: '/post-approve' },
                    // { text : 'รอการอนุมัติ(ประธาน)', to: '/approve-rf', count:''},
                ]
            },
            {
                active: false,
                text: 'การจัดการทั่วไป',
                subLinks: [
                    { text: 'จัดการแหล่งทุนวิจัย', to: '/budget-resource' },
                    { text: 'จัดการสังกัด', to: '/party' },
                ]
            },
        ],
        //ประธาน
        linksRole_4: [
            {
                active: false,
                text: 'Dashboard',
                subLinks: [
                    { text: 'ข้อมูลจำนวนโครงร่างในแต่ละปี', to: '/dashboard' },
                ]
            },
            {
                active: false,
                text: 'การจัดการข่าวสาร',
                subLinks: [
                    {
                        text: 'ข่าวสารทั้งหมด',
                        to: '/all-news',
                    },
                ]
            },
            {
                active: false,
                text: 'การจัดการการประชุม',
                subLinks: [
                    {
                        text: 'จัดการการประชุม',
                        to: '/meeting',
                    },
                    {
                        text: 'จัดการการประชุมย่อย',
                        to: '/sub-meeting',
                    },
                    // {
                    //     text : 'เข้าร่วมการประชุม(อนุกรรมการ)',
                    //     to    : '/join-meeting',
                    // },
                ]
            },
            {
                active: false,
                text: 'การจัดการผู้ใช้งาน',
                subLinks: [
                    {
                        text: 'จัดการผู้ใช้งาน',
                        to: '/user-management',
                        count: '',
                    },
                    {
                        text: 'จัดการใบ Certificate',
                        to: '/certificate-management',
                        count: '',
                    },
                ]
            },
            {
                active: false,
                text: 'การจัดการงานวิจัย (Pre-Approval)',
                subLinks: [
                    { text: 'งานวิจัยใหม่', to: '/new-research', count: '' },
                    { text: 'งานวิจัยทั้งหมด', to: '/all-research', count: '' },
                    { text: 'โครงการที่รอระบุประเภทการพิจารณา', to: '/verified-research', count: '' },
                    { text: 'ประเมิน (อนุกรรมการ)', to: '/research-approve' },
                    { text: 'รอการอนุมัติ(ประธาน)', to: '/research-approve-leader', count: '' },
                    { text: 'งานวิจัยขอยกเลิกโครงการ', to: '/research-cancel', const: '' },
                ]
            },
            {
                active: false,
                text: 'การจัดการงานวิจัย (Post-Approval)',
                subLinks: [
                    { text: 'ตรวจสอบแบบฟอร์ม RF', to: '/verify-rf', count: '' },
                    { text: 'พิจารณาแบบฟอร์ม RF', to: '/verify-rf-all', count: '' },
                    { text: 'ประเมิน (อนุกรรมการ)', to: '/post-approve' },
                    { text: 'รอการอนุมัติ(ประธาน)', to: '/approve-rf', count: '' },
                ]
            },
            {
                active: false,
                text: 'การจัดการทั่วไป',
                subLinks: [
                    { text: 'จัดการแหล่งทุนวิจัย', to: '/budget-resource' },
                    { text: 'จัดการสังกัด', to: '/party' },
                ]
            },
        ],
    }),
    created() {
        this.getResearchList(1);
        this.getNewResearchList(1);
        this.getRFAll({ page: 1, filter: 1, });
        this.getRF({ page: 1, filter: 1, });
        // this.getUserList(1);
        this.getCertificateList(1);
        this.getVerifiedResearchList({ page: 1, considerType: 4, });
        this.getResearchApprove({ page: 1, considerType: 4, });
        this.getRFApprove({ page: 1, filter: 1, });
    
    },
    computed: {
        ...mapState({
            user: state => state.Auth.user,
            role: state => state.Auth.role,
        }),
        ...mapState({
            role: state => state.Auth.role,
            newResearchCount: state => state.Research.newResearchCount,
            allResearchCount: state => state.Research.allResearchCount,
            countApproveRF: state => state.FormRF.countApproveRF,
            countVerifyRF: state => state.FormRF.countVerifyRF,
            userAdminCount: state => state.User.userAdminCount,
            certificateCount: state => state.User.certificateCount,
            verifyResearchCount: state => state.Research.verifyResearchCount,
            researchApproveCount: state => state.Research.researchApproveCount,
            rfApproveCount: state => state.Research.rfApproveCount,
            cancelResearchCount: state => state.Research.cancelResearchCount
        })
    },
    methods: {
        ...mapActions("Research", ["getResearchList", "getNewResearchList", "getVerifiedResearchList", "getResearchApprove", "getRFApprove"]),
        ...mapActions("FormRF", ["getRFAll", "getRF"]),
        ...mapActions("User", ["getUserAdminList", "getCertificateList"]),

        checkRole() {
            if (this.role === 1) {
                this.linksRole_1[4].subLinks[0].count = this.newResearchCount;
                this.linksRole_1[4].subLinks[1].count = this.allResearchCount;
                this.linksRole_1[4].subLinks[2].count = this.verifyResearchCount;
                this.linksRole_1[4].subLinks[4].count = this.researchApproveCount;
                this.linksRole_1[4].subLinks[5].count = this.cancelResearchCount;
                this.linksRole_1[5].subLinks[3].count = this.rfApproveCount;
                this.linksRole_1[5].subLinks[0].count = this.countVerifyRF;
                this.linksRole_1[5].subLinks[1].count = this.countApproveRF;
                this.linksRole_1[3].subLinks[1].count = this.userAdminCount;
                this.linksRole_1[3].subLinks[2].count = this.certificateCount;
                return this.linksRole_1;
            }
            if (this.role === 2) {
                // this.linksRole_2[3].subLinks[0].count = this.newResearchCount;
                // this.linksRole_2[3].subLinks[1].count = this.allResearchCount;
                this.linksRole_2[4].subLinks[0].count = this.verifyResearchCount;
                // this.linksRole_2[3].subLinks[4].count = this.researchApproveCount;
                // this.linksRole_2[5].subLinks[3].count = this.rfApproveCount;
                // this.linksRole_2[5].subLinks[0].count = this.countVerifyRF;
                // this.linksRole_2[5].subLinks[1].count = this.countApproveRF;
                // this.linksRole_2[3].subLinks[0].count = this.userAdminCount;
                // this.linksRole_2[3].subLinks[1].count = this.certificateCount;
                return this.linksRole_2;
            }
            if (this.role === 3) {
                // this.linksRole_3[3].subLinks[0].count = this.newResearchCount;
                // this.linksRole_3[3].subLinks[1].count = this.allResearchCount;
                // this.linksRole_3[4].subLinks[0].count = this.verifyResearchCount;
                // this.linksRole_3[4].subLinks[2].count = this.researchApproveCount;
                // this.linksRole_3[5].subLinks[3].count = this.rfApproveCount;
                // this.linksRole_3[5].subLinks[0].count = this.countVerifyRF;
                // this.linksRole_3[5].subLinks[1].count = this.countApproveRF;
                // this.linksRole_3[3].subLinks[0].count = this.userAdminCount;
                // this.linksRole_3[3].subLinks[1].count = this.certificateCount;
                return this.linksRole_3;
            }
            if (this.role === 4) {
                this.linksRole_4[4].subLinks[0].count = this.newResearchCount;
                this.linksRole_4[4].subLinks[1].count = this.allResearchCount;
                this.linksRole_4[4].subLinks[2].count = this.verifyResearchCount;
                this.linksRole_4[4].subLinks[4].count = this.researchApproveCount;
                this.linksRole_4[4].subLinks[5].count = this.cancelResearchCount;
                this.linksRole_4[5].subLinks[3].count = this.rfApproveCount;
                this.linksRole_4[5].subLinks[0].count = this.countVerifyRF;
                this.linksRole_4[5].subLinks[1].count = this.countApproveRF;
                this.linksRole_4[3].subLinks[0].count = this.userAdminCount;
                this.linksRole_4[3].subLinks[1].count = this.certificateCount;
                return this.linksRole_4;
            }
        },
        onClick(item) {
            if (item === 'activeMainMenu') {
                this.activeMainMenu = true;
                for (const link of this.checkRole()) {
                    link.active = false;
                }
            } else {
                this.activeMainMenu = false;
                for (const link of this.checkRole()) {
                    if (link.text === item.text) {
                        if (item.active === true) {
                            link.active = false;
                        } else {
                            link.active = true;
                        }
                    } else {
                        link.active = false;
                    }
                }
            }

        }
    }
}
</script>

<style lang="scss">
.menu-header {
    background-color: #3E7662;
}

.theme--light.v-expansion-panels .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon {
    color: #ffffff !important;
}

.side-menu {
    border-left-style: solid;
    border-left-color: #3E7662;
    border-width: 1px;
    color: black;
    cursor: pointer;
    text-align: left;
    padding-left: 10px;
}

.side-menu:hover {
    color: #3E7662;
    font-weight: bold;
}

.v-list-item__title {
    /*color: white;*/
}

.v-expansion-panel.py-1.header-side-menu {
    padding-bottom: 0 !important;
    padding-top: 0 !important;
    margin-top: 5px;
}

.v-expansion-panel-content__wrap {
    padding-top: 15px !important;
}

.fix-margin {
    .v-expansion-panel-content__wrap {
        padding-top: 0 !important;
        padding-bottom: 0;
        padding-left: 0;
        padding-right: 0;
    }

    a.fix-list-item.v-list-item--active.v-list-item.v-list-item--link.theme--light {
        color: #3e7662;
    }

    .fix-list-item {
        .v-list-item__icon.fix-list-icon {
            margin-right: 10px;
        }
    }
}

.hover-sidebar:hover {
    cursor: pointer;
    background-color: #ffffff1f;
}

.active-main-menu {
    background-color: #3E7662;
}
</style>
